import { themeGet } from '@styled-system/theme-get'
import { Box, Flex, Hide, Image, Text } from 'pcln-design-system'
import React from 'react'
import styled from 'styled-components'
import SponsoredBy from '../../SponsoredBy/SponsoredBy'
import { getHeroOverlineImageMaxHeights } from '../../utils/utils'

function OverlayText(props) {
  const StyledOverlineImage = styled(Image)`
    max-height: ${(props) => getHeroOverlineImageMaxHeights(props.maxHeight)[0]};
    margin-left: auto;
    margin-right: auto;
    ${themeGet('mediaQueries.lg')} {
      ${(props) => (props.isToutAvailable ? 'margin: 0;' : 'margin: auto;')}
      max-height: ${(props) => getHeroOverlineImageMaxHeights(props.maxHeight)[1]};
    }
  `
  const StyledText = styled(Text)`
    text-shadow: ${(props) =>
      props.color === 'text.dark' || props.color === 'text.heading' ? 'none' : '0 1px 2px rgba(0,0,0,0.5)'};
  `

  const {
    heading,
    subheading,
    overlineImage,
    overline,
    sponsoredByImage,
    isToutAvailable,
    maxOverlineImageHeight,
    overlineImagePosition,
    textColor = 'text.lightest',
  } = props

  return (
    <Flex
      mt={['2', null, null, '0']}
      flexDirection={overlineImagePosition === 'bottom' ? 'column-reverse' : 'column'}
      style={{ gap: '8px' }}
    >
      {overlineImage?.url && (
        <Box>
          <StyledOverlineImage
            isToutAvailable={isToutAvailable}
            alt={overlineImage.altText}
            src={overlineImage.url}
            mb={2}
            maxHeight={maxOverlineImageHeight}
          />
        </Box>
      )}
      <Box>
        {overline && (
          <StyledText
            textAlign={['center', null, null, isToutAvailable ? 'left' : 'center']}
            color={textColor}
            textStyle='overline'
            mb={2}
          >
            {overline}
          </StyledText>
        )}
        <Hide lg xl xxl>
          {heading && (
            <StyledText textAlign='center' color={textColor} textStyle='heading2' mb={2}>
              {heading}
            </StyledText>
          )}
          {subheading && (
            <StyledText textAlign='center' color={textColor} textStyle='subheading4'>
              {subheading}
            </StyledText>
          )}
        </Hide>
        <Hide xs sm md>
          {heading && (
            <StyledText
              textAlign={isToutAvailable ? 'left' : 'center'}
              color={textColor}
              textStyle='title3'
              mb={2}
            >
              {heading}
            </StyledText>
          )}
          {subheading && (
            <StyledText
              textAlign={isToutAvailable ? 'left' : 'center'}
              color={textColor}
              textStyle='subheading3'
            >
              {subheading}
            </StyledText>
          )}
        </Hide>
        {sponsoredByImage?.url && (
          <Flex
            alignItems={['center', null, null, isToutAvailable ? 'left' : 'center']}
            justifyContent={['center', null, null, isToutAvailable ? 'left' : 'center']}
            mt={[3, 3, 3, 4]}
          >
            {SponsoredBy(sponsoredByImage)}
          </Flex>
        )}
      </Box>
    </Flex>
  )
}

export default OverlayText
